import React, { FunctionComponent } from 'react';

import classnames from 'classnames';
import { isNull, isUndefined } from 'lodash';
import { useTranslation } from 'react-i18next';

import { Number } from 'core/number/Number';
import { RatingScaleProps, RatingScaleItemProps } from 'core/rating/types';
import { parseSize } from 'core/rating/util/Props';

import 'core/rating/rating-scale/RatingScale.scss';

const RatingScaleItem: FunctionComponent<RatingScaleItemProps> = ({ className, sentimentImage, sentimentLabel }) => (
    <li className={classnames('scale-item', className)}>
        {sentimentImage && (
            <div className="scale-img-container">
                <img src={sentimentImage} alt={typeof sentimentLabel === 'string' ? sentimentLabel : ''} />
            </div>
        )}
        {sentimentLabel && <div className="scale-label">{sentimentLabel}</div>}
    </li>
);

export const RatingScale: FunctionComponent<RatingScaleProps> = ({
    className,
    isDisplayScaleValue,
    sentimentNegativeImage,
    sentimentNegativeLabel: sentimentNegativeLabelFromProps,
    sentimentNeutralImage,
    sentimentNeutralLabel: sentimentNeutralLabelFromProps,
    sentimentPositiveImage,
    sentimentPositiveLabel: sentimentPositiveLabelFromProps,
    selectedValue,
    size,
}) => {
    const { t } = useTranslation('core/rating');
    const sentimentNegativeLabel = (
        isUndefined(sentimentNegativeLabelFromProps) ? t('SENTIMENT_NEGATIVE') : sentimentNegativeLabelFromProps
    ) as string | null;
    const sentimentPositiveLabel = (
        isUndefined(sentimentPositiveLabelFromProps) ? t('SENTIMENT_POSITIVE') : sentimentPositiveLabelFromProps
    ) as string | null;
    const sentimentNeutralLabel = (
        isUndefined(sentimentNeutralLabelFromProps) ? t('SENTIMENT_NEUTRAL') : sentimentNeutralLabelFromProps
    ) as string | null;

    return (
        <ol className={classnames(`r4e-rating-scale size-${size}`, className)}>
            <RatingScaleItem
                className="scale-negative"
                sentimentImage={sentimentNegativeImage}
                sentimentLabel={sentimentNegativeLabel}
            />
            <RatingScaleItem
                className="scale-neutral"
                sentimentImage={sentimentNeutralImage}
                sentimentLabel={sentimentNeutralLabel}
            />
            <RatingScaleItem
                className="scale-positive"
                sentimentImage={sentimentPositiveImage}
                sentimentLabel={sentimentPositiveLabel}
            />
            {isDisplayScaleValue && !isUndefined(selectedValue) && !isNull(selectedValue) && (
                <RatingScaleItem
                    className="scale-selected-value"
                    sentimentLabel={<Number value={selectedValue} precision={1} />}
                />
            )}
        </ol>
    );
};

RatingScale.defaultProps = {
    className: undefined,
    isDisplayScaleValue: true,
    sentimentNegativeImage: undefined,
    sentimentNegativeLabel: undefined,
    sentimentNeutralImage: undefined,
    sentimentNeutralLabel: undefined,
    sentimentPositiveImage: undefined,
    sentimentPositiveLabel: undefined,
    selectedValue: undefined,
    size: parseSize(),
};
